//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpdateCargoLimit = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCargoLimit,
        method: RequestType.PUT,
        data,
    });

const UpdateCargoCompanyPriorityCity = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCargoCompanyPriorityCity,
        method: RequestType.POST,
        data,
    });

const DeleteCargoCompanyPriorityCity = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteCargoCompanyPriorityCity,
        method: RequestType.DELETE,
        data,
    });

const SendDeliveryList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SendDeliveryList,
        method: RequestType.POST,
        data,
    });

const CargoManagementCommand = {
    UpdateCargoLimit,
    SendDeliveryList,
    DeleteCargoCompanyPriorityCity,
    UpdateCargoCompanyPriorityCity,
};

export default CargoManagementCommand;
